export const pricingData = [
    {
        price: "10000",
        title: "Bachelor of Science",
        img:"/images/blogs/im1.png",
        features: [
            "Flexible Pricing Plans",
            "Transparent Pricing",
            "Value for Money",
            "Special Offers",
        ],
    },
    {
        price: "10000",
        title: "Diploma",
      img:"/images/blogs/im3.png",
        features: [
            "Flexible Pricing Plans",
            "Transparent Pricing",
            "Value for Money",
            "Special Offers",
        ],
    },
    {
        price: "10000",
        title: "Nursing",
     img:"/images/blogs/im2.png",
        features: [
            "Flexible Pricing Plans",
            "Transparent Pricing",
            "Value for Money",
            "Special Offers",
        ],
    },
]; 